var map = {
	"./WaterMarkImage.png": "95d5",
	"./Zoox_Pass.png": "e5e7",
	"./Zoox_Pay_.png": "5776",
	"./accor-logo.png": "cbef",
	"./amex.png": "6e80",
	"./avatar-man.png": "cb0d",
	"./avatar-woman.png": "080a",
	"./cardbackground.png": "c440",
	"./cartao.png": "1513",
	"./check_circle_outline_24px.png": "37ec",
	"./favicon.png": "8925",
	"./ibis-logo.png": "661c",
	"./logo-smart.png": "797f",
	"./logo_zoox.png": "1acd",
	"./mastercard.png": "3c3e",
	"./placeholder.png": "aa6f",
	"./produto_pass.png": "1c4a",
	"./room_service_24px.png": "ba33",
	"./smartpass-logo.png": "d093",
	"./visa.png": "a236",
	"./whatsapp.png": "d253"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";